import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import Pusher, {Channel} from 'pusher-js';

@Injectable({
  providedIn: 'root'
})
export class PusherManagerService {

  private pusher!: Pusher;
  private readonly subscriptions: Map<string, Channel> = new Map<string, Channel>();

  constructor() {
    this.initPusher();
  }


  /**
   * Inicializar pusher
   *
   */
  initPusher() {
    this.pusher = new Pusher(environment.pusher.key, {
      cluster: environment.pusher.cluster,
      forceTLS: true,
    });
  }


  /**
   * Conectar canal de pusher
   *
   */
  observe(nameChannel: string, itemChannel: string = ''): Channel | null {

    if (!nameChannel) {
      return null;
    }

    const channelName: string = nameChannel + itemChannel;

    if (this.subscriptions.has(channelName)) {
      return null;
    }

    try {
      const channel: Channel = this.pusher.subscribe(channelName);
      this.subscriptions.set(channelName, channel);

      channel.bind('pusher:subscription_error', (error: any) => {
        console.error(`Error subscribing to the channel ${channelName}: `, error);
        this.subscriptions.delete(channelName);
      });

      return channel;

    } catch (error) {
      console.error(`Error subscribe to the channel ${channelName}: `, error);
      return null;
    }
  }


  /**
   * Desconectar canal específico de pusher
   *
   */
  disconnect(nameChannel: string, itemChannel: string = '') {
    const channelName: string = nameChannel + itemChannel;

    if (!this.subscriptions.has(channelName)) {
      return;
    }

    this.pusher.unsubscribe(channelName);
    this.subscriptions.delete(channelName);
  }


  /**
   * Desconectar todos los canales
   *
   */
  disconnectAll() {
    this.subscriptions.forEach((_, channelName) => {
      this.pusher.unsubscribe(channelName);
    });

    this.subscriptions.clear();
  }

}
